import { Grid } from "@material-ui/core";
import { countries } from "api";
import React from "react";
import {
    DateFieldFormik,
    InputFieldFormik,
    SelectFieldFormik,
} from "ui/componentes";

const countryOptions = countries.map((country) => ({
    label: country.label,
    value: country.code,
}));

const UserProfileForm = ({ disabled = false }) => {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
                <InputFieldFormik
                    required
                    autoFocus
                    disabled={disabled}
                    id="firstName"
                    name="firstName"
                    label="Nome"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <InputFieldFormik
                    required
                    disabled={disabled}
                    id="lastName"
                    name="lastName"
                    label="Sobrenome"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <DateFieldFormik
                    disabled={disabled}
                    id="privateInfo.birthDate"
                    name="privateInfo.birthDate"
                    label="Data Nascimento"
                    fieldType="keyboardDatePicker"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <SelectFieldFormik
                    disabled={disabled}
                    id="country"
                    name="country"
                    label="País"
                    options={countryOptions}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <InputFieldFormik
                    disabled={disabled}
                    id="privateInfo.phoneNumber"
                    name="privateInfo.phoneNumber"
                    label="Telefone"
                />
            </Grid>
        </Grid>
    );
};

export { UserProfileForm };
